module.exports = __webpack_public_path__ + "img/wrap-icon.c8c0b085.svg";